module.exports = __webpack_public_path__ + "img/time.c6cf2048.png";